var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddressIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2377 32C11.9477 31.7788 11.616 31.5918 11.3757 31.332C8.49153 28.2236 5.84291 24.949 3.63492 21.3863C2.35307 19.317 1.23145 17.178 0.529632 14.8667C-0.515077 11.3976 -0.0311778 8.12296 2.13195 5.13629C4.19252 2.29954 7.09912 0.598385 10.7732 0.123368C14.3672 -0.341258 17.6071 0.509319 20.4127 2.6276C22.8851 4.49501 24.3576 6.93245 24.8608 9.86123C25.2517 12.1443 24.7807 14.3145 23.9298 16.4387C22.789 19.2844 21.1562 21.891 19.3472 24.4071C17.6006 26.821 15.6928 29.1313 13.635 31.3246C13.393 31.5844 13.0613 31.7699 12.7729 31.9926L12.2377 32ZM12.4685 17.4229C15.8766 17.4763 18.7287 14.8786 18.7912 11.6633C18.8537 8.44805 16.0673 5.8117 12.5614 5.75529C9.13085 5.70185 6.27393 8.30406 6.22265 11.5297C6.17138 14.7554 8.9578 17.365 12.4685 17.4229Z",
    fill: "url(#paint0_linear_580_830)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_580_830",
    x1: 12.5,
    y1: 0,
    x2: 12.5,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAA520"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIcon);
export default __webpack_public_path__ + "static/media/addressIcon.c77be24bcfd0c3e1093d534073f85958.svg";
export { ForwardRef as ReactComponent };